import * as React from 'react'
import { LogoLoader } from './logo-loader'

export function RoutePending() {
  const [isHydrated, setIsHydrated] = React.useState(false)

  React.useEffect(() => {
    setIsHydrated(true)
  }, [])

  if (!isHydrated) {
    return null
  }

  return <LogoLoader fullScreen className="h-[120px] w-[120px]" />
}
